// extracted by mini-css-extract-plugin
export default {"menu-bar":"MenuBar_menu-bar__WeX4K","logo":"MenuBar_logo__jA0rZ","links":"MenuBar_links__mLvhW","link":"MenuBar_link__t-5IK","selected":"MenuBar_selected__Zxxhv"};